import { useLogout } from '@app/core/auth/authentication/components/useLogout';
import { SplashLoader } from '@mi-front/ui';
import { useEffect } from 'react';

export function LogoutPage() {
  const logout = useLogout();

  useEffect(() => {
    logout();
  }, []);

  return <SplashLoader />;
}
